<template>
    <el-form
        ref="formRef"
        style="max-width: 600px; margin: auto"
        :model="dataForm"
        :rules="rules"
        :disabled="loading"
        label-width="auto"
        v-loading="loading"
    >

        <el-form-item
            :label="i18n.tkey('lang_mall_name')"
            prop="recordname"
            tkey="商場名稱"
        >
            <el-input
                v-model="dataForm.recordname"
                type="text"
                autocomplete="off"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_mall_name_en')"
            prop="addinfo6"
            tkey="商場英文名稱"
        >
            <el-input
                v-model="dataForm.addinfo6"
                type="text"
                autocomplete="off"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_area_text')"
            prop="addinfo5"
            tkey="地區"
        >
            <CountrySelector
                v-model="dataForm.addinfo5"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_mall_des')"
            prop="addinfo7"
            tkey="商場描述"
        >
            <el-input
                v-model="dataForm.addinfo7"
                type="text"
                autocomplete="off"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_mall_des_en')"
            prop="addinfo8"
            tkey="商場英文描述"
        >
            <el-input
                v-model="dataForm.addinfo8"
                type="text"
                autocomplete="off"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_mall_model')"
            tkey="商場模型"
        >
            <el-select
                :placeholder="i18n.tkey('lang_mall_model')"
                v-model="dataForm.addinfo19.mode"
            >
                <el-option
                    v-for="item in modeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
            </el-select>
        </el-form-item>

      <el-form-item
          :label="i18n.tkey('land_disable_auxiliary_collection')"
          tkey="禁用輔助收款"
      >
        <el-select
            :placeholder="i18n.tkey('land_disable_auxiliary_collection')"
            v-model="dataForm.addinfo23"
        >
          <el-option
              :key="'0'"
              :label="i18n.tkey('lang_enable')"
              :value="''"
          />
          <el-option
              :key="'1'"
              :label="i18n.tkey('lang_disable')"
              :value="'1'"
          />
        </el-select>
      </el-form-item>

      <el-form-item
          :label="i18n.tkey('land_hall_model')"
          tkey="模型"
      >
        <el-select
            :placeholder="i18n.tkey('land_hall_model')"
            v-model="dataForm.addinfo24"
        >
          <el-option
              :key="'0'"
              :label="i18n.tkey('land_hall_exhibition_model')"
              :value="''"
          />
<!--          <el-option
              :key="'1'"
              :label="i18n.tkey('land_hall_exhibition_model2')"
              :value="'1'"
          />-->
          <el-option
              :key="'2'"
              :label="i18n.tkey('land_hall_exhibition_model3')"
              :value="'2'"
          />
        </el-select>
      </el-form-item>


      <el-form-item
            :label="i18n.tkey('lang_stage')"
            v-if="dataForm.addinfo19.mode != 0"
            tkey="舞台圖片"
        >
            <div>
                <el-select
                    :placeholder="i18n.tkey('lang_stage')"
                    v-model="dataForm.addinfo19.stageBack"
                    @change="changeStageImg"
                >
                    <el-option
                        v-for="item in stageImgList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
                <br>
                <UploadImg
                    v-model="dataForm.addinfo19.stageBackground"
                    :width="200"
                    :height="100"
                    :sizeLimit="500"
                    :readonlyTag="dataForm.addinfo19.stageBack != -1"
                    :useBtn="false"
                    style="margin-top: 10px"
                />
            </div>

        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_mall_signboard')"
            prop="addinfo11"
            tkey="商場招牌"
        >
            <div>
                <div class="img-size-label">
                    <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>800*400</span>
                </div>

                <UploadImg
                    v-model="dataForm.addinfo11"
                    :sizeLimit="500"
                    :readonlyTag="readonlyTag"
                    :useBtn="readonlyTag !== true"
                />
            </div>
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_mall_signboard_en')"
            prop="addinfo12"
            tkey="商場英文招牌"
        >
            <div>
                <div class="img-size-label">
                    <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>800*400</span>
                </div>

                <UploadImg
                    v-model="dataForm.addinfo12"
                    :sizeLimit="500"
                    :readonlyTag="readonlyTag"
                    :useBtn="readonlyTag !== true"
                />
            </div>
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_mall_banner_img')"
            prop="addinfo15"
            tkey="商場條幅"
        >
            <div>
                <div class="img-size-label">
                    <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>120*720</span>
                </div>

                <UploadImg
                    v-model="dataForm.addinfo15"
                    :sizeLimit="500"
                    :readonlyTag="readonlyTag"
                    :useBtn="readonlyTag !== true"
                />
            </div>
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_mall_banner_img_en')"
            prop="addinfo16"
            tkey="商場英文條幅"
        >
            <div>
                <div class="img-size-label">
                    <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>120*720</span>
                </div>

                <UploadImg
                    v-model="dataForm.addinfo16"
                    :sizeLimit="500"
                    :readonlyTag="readonlyTag"
                    :useBtn="readonlyTag !== true"
                />
            </div>

        </el-form-item>

        <el-form-item>
            <div style="text-align: center; width: 100%">
                <el-button type="primary" @click="submitForm(formRef)" v-if="null == editObj" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
                <el-button type="primary" @click="submitForm(formRef)" v-if="null != editObj && readonlyTag !== true" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
                <el-button @click="goHallView" v-if="null != editObj && readonlyTag === true" tkey="查看">{{i18n.tkey("lang_check")}}</el-button>
                <!--            <el-button @click="resetForm(formRef)">Reset</el-button>-->
            </div>
        </el-form-item>
    </el-form>

    <div
        v-if="null != editObj && (null == readonlyTag || false === readonlyTag)"
        class="edit-company-box"
    >
        <PageTitle :titleText="i18n.tkey('lang_shop_settled_in')" />

        <HallCompanyEditor
            :hallObj="editObj"
            type="1"
        />
    </div>

</template>

<script setup>
import {inject, reactive, ref, toRef, onBeforeMount, getCurrentInstance} from 'vue'
import eshopopeeApi from "@/request/eshopopeeApi";
import {useCompanyinfo} from "@/stores/companyinfo";
import myUtil from "@/util/util";
import CountrySelector from "@/components/shopopee/country/countrySelector.vue";
import UploadImg from "@/components/shopopee/form/uploadImg.vue";
import record14Api from "@/request/record14Api";
import HallCompanyEditor from "@/components/shopopee/hallManager/hallCompanyEditor.vue";
import PageTitle from "@/components/shopopee/common/pageTitle.vue";
import record15Api from "@/request/record15Api";
import {useUserinfo} from "@/stores/userinfo";

const props = defineProps(["editObj", "readonlyTag", "companyObj"])
const emits = defineEmits(["save-complete"])

const { proxy } = getCurrentInstance()
const i18n = inject("i18n")
const reload = inject("reload");

//響應機制的companyinfo
const companyInfoRef = toRef(useCompanyinfo())
const userInfoRef = toRef(useUserinfo())

const loading = ref(false)

const formRef = ref(null)

const shopCompany = ref({})
const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return companyInfoRef.value } })

const rules = reactive({
    recordname: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo5: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo7: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo8: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    // addinfo11: [
    //     { required: true, message: i18n.tkey("lang_enter_complete") },
    // ],
    // addinfo12: [
    //     { required: true, message: i18n.tkey("lang_enter_complete") },
    // ],
    // addinfo15: [
    //     { required: true, message: i18n.tkey("lang_enter_complete") },
    // ],
    // addinfo16: [
    //     { required: true, message: i18n.tkey("lang_enter_complete") },
    // ],
})

const dataForm = reactive({
    recordname: '',
    addinfo5: 'HK',
    addinfo6: '',
    addinfo7: '',
    addinfo8: '',
    addinfo11: null,
    addinfo12: null,
    addinfo15: null,
    addinfo16: null,
    addinfo17: '1',
    addinfo23: '',
    addinfo24:'',
    addinfo19: {
        stageBackground: `${proxy.$ThreeDShopopeePath}mymodels/gltf/island/pav/stage_background.jpg`,
        mode: 0,
        stageBack: 0
    }
})

const submitForm = (formEl) => {
    if (!formEl) return
    formEl.validate((valid) => {
        if (valid) {
            if (null == props.editObj){
                submitData()
            }else{
                updateData()
            }

        }
    })
}

//商場模式下拉框的選項
const modeList = ref([
    {
        label: i18n.tkey("lang_server_center"),
        value: 0
    },
    {
        label: i18n.tkey("lang_speak_center"),
        value: 1
    },
    {
        label: i18n.tkey("lang_t_stage"),
        value: 2
    },
])

//舞台圖片下拉框的選項
const stageImgList = ref([
    {
        label: `${i18n.tkey("lang_img")} 1`,
        value: 0
    },
    {
        label: `${i18n.tkey("lang_img")} 2`,
        value: 1
    },
    {
        label: `${i18n.tkey("lang_custom_text")}`,
        value: -1
    },
])

//預設的舞台圖片
const imgUrlMap = {
    "0": `${proxy.$ThreeDShopopeePath}mymodels/gltf/island/pav/stage_background.jpg`,
    "1": `${proxy.$ThreeDShopopeePath}mymodels/gltf/island/pav/stage_background0.jpg`,
    "-1": null,
}

// const resetForm = (formEl) => {
//     if (!formEl) return
//     formEl.resetFields()
// }

function submitData() {
    loading.value = true

    const request = record14Api.insertRecord14
    const params = request.getParams()

    params.companycode = shopCompany.value.companycode
    params.recordname = dataForm.recordname
    params.addinfo5 = dataForm.addinfo5
    params.addinfo6 = dataForm.addinfo6
    params.addinfo7 = dataForm.addinfo7
    params.addinfo8 = dataForm.addinfo8
    params.addinfo11 = dataForm.addinfo11
    params.addinfo12 = dataForm.addinfo12
    params.addinfo15 = dataForm.addinfo15
    params.addinfo16 = dataForm.addinfo16
    params.addinfo17 = dataForm.addinfo17
    params.addinfo23 = dataForm.addinfo23
    params.addinfo24= dataForm.addinfo24
    params.addinfo19 = JSON.stringify(dataForm.addinfo19)

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))

            if (null != res.detail){
                addJoinRecord(res.detail)
            }

            emits("save-complete")
        }else{
            myUtil.alertError(res.msg)
        }
    })


}

function updateData(){
    loading.value = true

    const request = record14Api.updateRecord14
    const params = request.getParams()

    params.id = props.editObj.id
    // params.companycode = shopCompany.value.companycode
    params.recordname = dataForm.recordname
    params.addinfo5 = dataForm.addinfo5
    params.addinfo6 = dataForm.addinfo6
    params.addinfo7 = dataForm.addinfo7
    params.addinfo8 = dataForm.addinfo8
    params.addinfo11 = dataForm.addinfo11
    params.addinfo12 = dataForm.addinfo12
    params.addinfo15 = dataForm.addinfo15
    params.addinfo16 = dataForm.addinfo16
    params.addinfo17 = dataForm.addinfo17
    params.addinfo23 = dataForm.addinfo23
    params.addinfo24= dataForm.addinfo24
    params.addinfo19 = JSON.stringify(dataForm.addinfo19)

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            emits("save-complete")
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

function goHallView(){
    proxy.$router.push({
        path: `/hall/${props.editObj.id}`
    })

    if (proxy.$route.path.indexOf("/hall") != -1){
        reload()
    }
}

function fillEditInfo(){

    dataForm.recordname = props.editObj.recordname
    dataForm.addinfo5 = props.editObj.addinfo5
    dataForm.addinfo6 = props.editObj.addinfo6
    dataForm.addinfo7 = props.editObj.addinfo7
    dataForm.addinfo8 = props.editObj.addinfo8
    dataForm.addinfo23 = myUtil.isEmpty(props.editObj.addinfo23)?"":props.editObj.addinfo23
    dataForm.addinfo24 = myUtil.isEmpty(props.editObj.addinfo24)?"":props.editObj.addinfo24
    if (myUtil.isNotEmpty(props.editObj.addinfo11)){
        dataForm.addinfo11 = proxy.$ShopopeeUrl + props.editObj.addinfo11
    }

    if (myUtil.isNotEmpty(props.editObj.addinfo12)){
        dataForm.addinfo12 = proxy.$ShopopeeUrl + props.editObj.addinfo12
    }

    if (myUtil.isNotEmpty(props.editObj.addinfo15)){
        dataForm.addinfo15 = proxy.$ShopopeeUrl + props.editObj.addinfo15
    }

    if (myUtil.isNotEmpty(props.editObj.addinfo16)){
        dataForm.addinfo16 = proxy.$ShopopeeUrl + props.editObj.addinfo16
    }

    if (myUtil.isNotEmpty(props.editObj.addinfo19)){
        dataForm.addinfo19 = JSON.parse(props.editObj.addinfo19)
    }

    dataForm.addinfo17 = props.editObj.addinfo17

}

function addJoinRecord(obj){
    const request = record15Api.submitRecord15
    const params = request.getParams()

    params.additionalrecord15.companycode = shopCompany.value.companycode
    params.additionalrecord15.login = userInfoRef.value.id
    params.additionalrecord15.updatedid = obj.id
    params.additionalrecord15.recordno = "-1"
    params.additionalrecord15.addinfo12 = "{}"
    params.additionalrecord15.addinfo13 = "1"

    request.send(params, (res) => {
        if (res.code != 200){
            myUtil.alertError(res.msg)
        }
    })
}

function changeStageImg(){
    dataForm.addinfo19.stageBackground = imgUrlMap[dataForm.addinfo19.stageBack]
}

onBeforeMount(() => {
    if (null == props.companyObj){
        shopCompany.value = getShopCompanyObj()
    }else{
        shopCompany.value = props.companyObj
    }

    if (null != props.editObj){
        fillEditInfo()
    }
})

</script>

<style scoped>
.date-input {
    width: 100px;
}

.center-box {
    width: 45px;
    display: inline-block;
    text-align: right;
}

.edit-company-box {
    position: relative;
    margin-top: 30px;
    margin-bottom: 20px;
}

.img-size-label {
    color: #606266;
    text-align: left;
}
</style>